import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight } from 'lucide-react';
import api from '../utils/api';
import './OrderSuccessPage.css';

export default function OrderSuccessPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      api.get(`/orders/${orderId}`).then(res => setOrder(res.data.order)).catch(console.error);
    }
  }, [orderId]);

  return (
    <div className="success-page container">
      <div className="success-card">
        <CheckCircle size={72} className="success-icon" />
        <h1>Order Confirmed!</h1>
        <p>Thank you for your order. We've sent a confirmation email with all the details.</p>
        {order && (
          <div className="order-info">
            <div className="order-number">Order <span>{order.orderNumber}</span></div>
            <div className="order-items">
              {order.items?.map(item => (
                <div key={item._id} className="success-item">
                  <span>{item.name}</span>
                  <span>x{item.quantity}</span>
                  <span>CHF {(item.price * item.quantity).toFixed(2)}</span>
                </div>
              ))}
            </div>
            <div className="order-total">Total: <strong>CHF {order.total?.toFixed(2)}</strong></div>
          </div>
        )}
        <div className="success-actions">
          <Link to="/orders" className="btn-primary"><Package size={18} /> Track Orders</Link>
          <Link to="/shop" className="btn-secondary">Continue Shopping <ArrowRight size={18} /></Link>
        </div>
      </div>
    </div>
  );
}
